export default __webpack_public_path__ + "static/media/Bobbi 9781408349571.70b0b40c.jpg";